<template>
  <div class='EnbEmpty'>
    <div class="cont-info">
      <Empty-icon :color="Prefes.lojaCorFonte.color"/>
      <label>{{ label }}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EmptyIcon from './Icons/EmptyIcon'
export default {
  name: 'EnbEmpty',
  components: { EmptyIcon },
  props: {
    label: {
      type: String,
      default: 'Adicione algum texto aqui!'
    }
  },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.EnbEmpty {
  width: 100%;
  display: flex;
  justify-content: center;
}

.cont-info {
  margin-top: 10%;
}

label {
  display: block;
  font-size: 20px;
  padding-top: 2%;
}

@media (max-width: 500px) {
  .EnbEmpty {
    width: 80%;
    margin: auto;
    line-height: 22px;
  }
}
</style>
